<template>
    <div>
        <template v-if="auth_level >= route_auth_level(this)">
            <b-container fluid="lg" class="app-wrapper">
                <navbar v-if="route_navbar(this)" />
                <RouterView />
            </b-container>
        </template>
        <template v-else>
            <auth-mask />
        </template>
        <Notifications />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthMask from '@/components/AuthMask'
import Navbar from '@/components/Navbar'
import Notifications from '@/components/Notifications'

export default {
    components: {
       AuthMask,
       Navbar,
       Notifications,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'route_auth_level',
            'route_navbar',
        ])
    },
    methods: {
    },
    mounted() {
    },
}
</script>
